<div class="session" [class.inactive]="enableOkrSelectionOnly" data-test-id="objective-selector-session">
  <i class="fs-16px" [uiTooltipTitle]="'session' | localize" ui-icon ui-tooltip uiTheme="fill" uiType="session"></i>
  <div class="session-title sp-mb-0" ui-typography uiEllipsis>{{ session.title }}</div>
  <div class="session-range sp-px-14 sp-mb-0" ui-typography uiEllipsis>
    {{ session.start | dayjsDate : "DD MMMM, YYYY" }} -
    {{ session.end | dayjsDate : "DD MMMM, YYYY" }}
  </div>
  <button class="select-btn sp-ml-auto sp-mr-32" *ngIf="!enableOkrSelectionOnly" (click)="onSessionSelected(session)" ui-button uiType="primary" uiShape="round" data-test-id="select-button">
    {{ "select" | localize }}
  </button>
</div>
